<mbs-modal class="mbs-rd-enable">
  <ng-container modal-header>
    <span [innerHTML]="'shared:computers.enableConnect.titleAdmin' | i18next: { param: computerName }"></span>
  </ng-container>
  <ng-container modal-body>
    <mbs-alert
      [type]="mbsPopupType.danger"
      [icon]="true">
      {{ 'shared:computers.enableConnect.adminText' | i18next }}
    </mbs-alert>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button (click)="baseModal.close()">{{ 'shared:buttons.close' | i18next }}</mbs-button>
  </ng-container>
</mbs-modal>
